<div class="page-content">

    <div class="row">
        <div class="col-lg-12 progress-top-level centered">
            <h1 translate>CANCEL_INTERVIEW.HEADER</h1>
            <P class="divider hidden-xs"></P>
        </div>
    </div>

    <div class="container">
        <div class="content-panel">
            
            <div class="row">
                <div class="col-12 col-sm-8">
                    <h2 translate>CANCEL_INTERVIEW.BANNER</h2>
                </div>
            </div>

            <div class="sub-header">
                <h3 translate>SCHEDULE_INTERVIEW.REVIEW.SUMMARY</h3>
            </div>

            <dl class="dl-horizontal">
                <dt translate>SCHEDULE_INTERVIEW.REVIEW.LOCATION</dt>
                <dd translate>{{appointment?.location.name}}</dd>
                <dt translate>SCHEDULE_INTERVIEW.REVIEW.DATE</dt>
                <dd>{{appointment?.appointmentDate | date}}</dd>
                <dt translate>SCHEDULE_INTERVIEW.REVIEW.TIME</dt>
                <dd>{{appointment?.appointmentDate | date:'shortTime'}}</dd>
                <dt translate>SCHEDULE_INTERVIEW.REVIEW.FOR</dt>
                <dd>{{appointment?.user.name}}</dd>
            </dl>

        </div><!--[End] content panel -->

        <div class="row-button-group">
            
            <div class="pull-right col-12 col-sm-4 col-md-3 col-xs-offset-2 col-sm-offset-5 col-md-offset-7">
                <button id="submitCancellation" class="btn btn-nav btn-primary w-100 d-block" type="submit"
                        (click)="submitCancellation()" (keyup.enter)="submitCancellation()">
                    <span translate>GENERAL_REUSABLE.BUTTON_LABEL.SUBMIT</span>
                    <i class="fa fa-check"></i>
                </button>
            </div>
            
            <div class="col-12 col-sm-3 col-md-2">
                <a id="back" class="btn btn-default btn-nav w-100 d-block" name="back" (click)="goBack()" tabindex="0" (keyup.enter)="goBack()">
                    <i class="fa fa-chevron-left"></i>
                    <span translate>GENERAL_REUSABLE.BUTTON_LABEL.BACK_BUTTON</span>
                </a>
            </div>
        </div>
    </div><!-- [End] container -->

</div><!-- [End] page content -->
            